function Toast({ message, type = 'info', duration = 3000 }) {
  const bgColors = {
    success: 'bg-green-500',
    error: 'bg-red-500',
    info: 'bg-blue-500',
  };

  // Add pulsing animation for "permanent" toasts (duration = 0, but they auto-hide after 10s)
  const isPermanent = duration === 0;
  const animationClass = isPermanent ? 'animate-pulse' : 'animate-slide-up';

  return (
    <div className={`fixed bottom-20 left-1/2 transform -translate-x-1/2 z-[11000] ${animationClass}`}>
      <div className={`${bgColors[type]} text-white px-6 py-3 rounded-xl shadow-lg font-medium`}>
        {message}
      </div>
    </div>
  );
}

export default Toast;

